<template>
  <div class="evaluation-content">
    <header>
      <div class="index-wrapper">
        <span class="index">{{ index + 1 }}</span>
      </div>
      <div class="title-wrapper">
        <h1>{{ section.name }}</h1>
        <p
          v-html="section.description"
          class="description"
        />
      </div>
    </header>
    <main>
      <div
        v-for="(child, $childIndex) of section.$children"
        :key="child.$id"
      >
        <evaluation-section
          v-if="child.$group === 'subsection'"
          @comment="onComment"
          @evidence="onEvidence"
          :branch-type="branch.type"
          :item="child"
          :index="[index, $childIndex]"
        />
        <evaluation-question
          v-else
          @comment="onComment"
          @evidence="onEvidence"
          :branch-type="branch.type"
          :index="[index, $childIndex]"
          :item="child"
        />
      </div>
    </main>
    <evaluation-comment
      ref="evaluationComment"
      :item="commentItem"
    />
    <evaluation-evidence
      ref="evaluationEvidence"
      :item="evidenceItem"
    />

  </div>
</template>

////////////////////////////
//                   SCRIPT
////////////////////////////
<script>
import EvaluationSection from './evaluation-section'
import EvaluationQuestion from './evaluation-question'
import EvaluationComment from '@/modules/evaluation/components/layout/evaluation-comment'
import EvaluationEvidence from '@/modules/evaluation/components/layout/evaluation-evidence'

export default {
  name: 'EvaluationContent',
  components: {
    EvaluationEvidence,
    EvaluationComment,
    EvaluationSection,
    EvaluationQuestion
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    section: {
      type: Object,
      default () {
        return {}
      }
    },
    branch: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      commentItem: null,
      evidenceItem: null
    }
  },
  methods: {
    onComment (item) {
      this.$refs.evaluationEvidence.close()
      this.$refs.evaluationComment.open()
      this.commentItem = item
    },
    onEvidence (item) {
      console.log('On evidence')
      this.$refs.evaluationComment.close()
      this.$refs.evaluationEvidence.open()
      this.evidenceItem = item
    }
  }
}
</script>

////////////////////////////
//                    STYLE
////////////////////////////
<style
  lang="scss"
  scoped
>
.evaluation-content {
  margin: 20px;
  max-width: 100%;
  max-height: calc(100vh - 91px);
  header {
    display: flex;
    .index-wrapper {
      width: 50px;
      margin-right: 20px;
      float: left;
      text-align: center;
      .index {
        @include font-primary(12px, bold);
        display: inline-block;
        background-color: $color-ui-primary;
        color: #fff;
        box-shadow: 0 3px 3px rgba(0, 0, 0, 0.2);
        padding: 5px;
        min-width: 14px;
        text-align: center;
        border-radius: 2px;
        vertical-align: middle;
      }
    }
    .title-wrapper {
      h1 {
        margin: 0;
        line-height: 24px;
        @include font-primary(18px, semibold);
      }
      p.description {
        @include font-primary(14px, light);
        color: #666666;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/evaluation/components/layout/evaluation-content.vue